var React = require('react');

function GeneralAmenity (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"96","cy":"96","r":"54","stroke":"#000","strokeWidth":"4","key":0}),React.createElement("path",{"clipRule":"evenodd","d":"M119.4 69.3a4 4 0 0 1 1.8 5.4L100 118.3c-3.1 6.4-8.5 7.6-13.4 2.6l-11.9-12.2a4 4 0 0 1 0-5.6l2.9-2.8a4 4 0 0 1 5.7 0l7.4 7.6a1 1 0 0 0 1.6-.3l18.5-38a4 4 0 0 1 5.4-1.8l3.2 1.5Z","stroke":"#000","strokeWidth":"4","key":1})]);
}

GeneralAmenity.defaultProps = {"viewBox":"0 0 191 191","width":"191","height":"191","fill":"none"};

module.exports = GeneralAmenity;

GeneralAmenity.default = GeneralAmenity;
